import { produce } from 'immer'
import { create } from 'zustand'
import { CONTROLADOR_MAXIMA_POTENCIA_FOTOVOLTAICA_ATTR, DEFAULT_PROJETO_OFFGRID, DEFAULT_PROJETO_OFFGRID_MODALS, DEFAULT_PROJETO_OFFGRID_VALIDATIONS, ID_ATRIBUTO_BATERIA_TIPO_CHUMBO, ID_ATRIBUTO_BATERIA_TIPO_LITIO, INVERSOR_CARREGADOR_POTENCIA_MAXIMA_FV_ATTR, INVERSOR_ONDA_POTENCIA_MAXIMA_ATTR, MODULO_POTENCIA_MAXIMA_ATTR, MODULO_POTENCIA_MINIMA_ATTR, MODULO_POWER_ATTR, POSICAO_MODULO } from 'src/components/projetos/constants'
import { FormProjetoOffGridModalsType, FormProjetoOffGridType, FormProjetoOffGridValidationsType, ListagemItem, ModuloPorRegiaoListagemResponse, OptionWithEstrutura, SolucaoCalculadaOffGrid } from 'src/components/projetos/types'
import { BehaviorSubject } from "rxjs";
import { ID_INVERSOR_CARREGADOR, ID_INVERSOR_ONDA_MODIFICADA, ID_INVERSOR_ONDA_SENOIDAL } from 'src/components/componentes/types';
interface ProjetosOffGridStoreState {
  data: FormProjetoOffGridType
  validations: FormProjetoOffGridValidationsType
  modals: FormProjetoOffGridModalsType
}

interface ProjetosOffGridStoreActions {
  changeValue: (newValues: Partial<FormProjetoOffGridType>) => void
  limparCiclosBateriaSeIncompativel: () => void
  changeValidationsValue: (newValues: Partial<FormProjetoOffGridValidationsType>) => void
  changeModalsValue: (newValues: Partial<FormProjetoOffGridModalsType>) => void
  addModulos: (modulos: ModuloPorRegiaoListagemResponse[], moduloSelecionado?: { id: number, quantidade: number }) => void
  syncFileiras: (qtdModulo?: number, estruturaSelecionada?: any, alterouQtdModulos?: boolean) => void
  addSolucaoCalculada: (data: SolucaoCalculadaOffGrid) => void
  reset: () => void
}

interface ProjetosOffGridStore {
  state: ProjetosOffGridStoreState
  actions: ProjetosOffGridStoreActions
}

export const OFFGRID_ERROR_MESSAGES = {
  FILEIRAS_INVALIDAS: 'Atenção! Configuração das fileiras incorreta. Por favor, corrija as disposições conforme a quantidade de módulos sugerida/escolhida.',
}

const INITIAL_STATE: ProjetosOffGridStoreState = {
  data: DEFAULT_PROJETO_OFFGRID,
  validations: DEFAULT_PROJETO_OFFGRID_VALIDATIONS,
  modals: DEFAULT_PROJETO_OFFGRID_MODALS,
}
export const oldEstruturas$ = new BehaviorSubject<ListagemItem[]>([]);
export const acessouEditarEstruturas$ = new BehaviorSubject<boolean>(false);
export const useProjetosOffGridStore = create<ProjetosOffGridStore>()(
  (set, get) => {
    const setState = (fn: any) => set(produce<ProjetosOffGridStore>(fn))

    return {
      state: INITIAL_STATE,
      actions: {
        limparCiclosBateriaSeIncompativel: () => {
          setState(({ state }: ProjetosOffGridStore) => {
            const tipoBateria = state.data.tipo_bateria;
            const baterias = state.data.baterias || [];

            if (!baterias.length) {
              Object.assign<typeof state["data"], Partial<typeof state["data"]>>(state.data, { tipo_bateria: null, autonomia_banco_bateria: 0 })
              return;
            }
            
            const somenteLitio = baterias.every(item => item.tipo === ID_ATRIBUTO_BATERIA_TIPO_LITIO)
            const somenteChumbo = baterias.every(item => item.tipo === ID_ATRIBUTO_BATERIA_TIPO_CHUMBO)

            if (somenteChumbo && tipoBateria && tipoBateria?.id !== "chumbo") {
              Object.assign<typeof state["data"], Partial<typeof state["data"]>>(state.data, { tipo_bateria: null, autonomia_banco_bateria: 0 })
              Object.assign<typeof state["validations"], Partial<typeof state["validations"]>>(state.validations, { tipo_bateria: {
                status: false,
                helper: "Permitido nesta UF: Bateria de chumbo"
              } })
              return;
            }

            if (somenteLitio && tipoBateria && tipoBateria?.id !== "litio") {
              Object.assign<typeof state["data"], Partial<typeof state["data"]>>(state.data, { tipo_bateria: null, autonomia_banco_bateria: 0 })
              Object.assign<typeof state["validations"], Partial<typeof state["validations"]>>(state.validations, { tipo_bateria: {
                status: false,
                helper: "Permitido nesta UF: Bateria de lítio"
              } })
              return;
            }

            if (baterias.length) {
              Object.assign<typeof state["validations"], Partial<typeof state["validations"]>>(state.validations, { tipo_bateria: {
                status: true,
                helper: ""
              } })
            }
          })
        },
        addModulos: (modulos: ModuloPorRegiaoListagemResponse[], moduloSelecionado?: { id: number, quantidade: number }) => {
          setState(({ state }: ProjetosOffGridStore) => {
            const newModulos = modulos.map(modulo => {
              const potencia = modulo.atributos.find(item => item.atributo === MODULO_POWER_ATTR)
              const potenciaMaxima = modulo.atributos.find(item => item.atributo === MODULO_POTENCIA_MAXIMA_ATTR)
              const potenciaMinima = modulo.atributos.find(item => item.atributo === MODULO_POTENCIA_MINIMA_ATTR)

              return {
                potenciaMaxima: Number(potenciaMaxima?.valor || 0),
                potenciaMinima: Number(potenciaMinima?.valor || 0),
                componente_id: modulo.id,
                inversoresTipos: [],
                categoria_componentes_id: modulo.categoria_componentes_id,
                potencia: Number(potencia?.valor || 0),
                faturamento: modulo.data_previsao_faturamento ? new Date(modulo.data_previsao_faturamento).toISOString() : undefined,
                nome: modulo.nome,
                descricao: modulo.descricao,
                quantidade: 0,
                selecionado: false,
                categoria: modulo.categoria_componentes_nome,
                altura: modulo.altura,
                largura: modulo.largura,
                peso: modulo.peso,
                valor: 0, // Calculado no backend
                comprimento: modulo.comprimento,
                valor_unitario: 0,
                regioes_parametros: modulo?.regioes_parametros,
                finame: modulo?.finame,
                exibir_popup_parceiro: modulo.exibir_popup_parceiro,
                
              }
            })

            if (moduloSelecionado) {
              const selectedModulo = newModulos.find(modulo => modulo.componente_id === moduloSelecionado.id)
              if (selectedModulo) {
                selectedModulo.quantidade = moduloSelecionado.quantidade
                Object.assign<typeof state["data"], Partial<typeof state["data"]>>(state.data, { modulo_selecionado: selectedModulo })
              }
            }

            Object.assign<typeof state["data"], Partial<typeof state["data"]>>(state.data, { modulos: newModulos })
          })
        },
        addSolucaoCalculada: (data: SolucaoCalculadaOffGrid) => {
          setState(({ state }: ProjetosOffGridStore) => {
            const newBaterias = data.baterias.map(item => ({
              ...item,
              potencia: item.potencia || 0,
              valor: 0,
              componente_id: item.id,
            }))

            const newControladores = data.controladores.map(item => ({
              ...item,
              potencia: item.potencia || Number(item.atributos.find(item => item.atributo === CONTROLADOR_MAXIMA_POTENCIA_FOTOVOLTAICA_ATTR)?.valor || 0),
              valor: 0,
              componente_id: item.id,
            }))
            
            const newInversores = data.inversores.map(item => {
              let potencia = 0;

              if (!!item.potencia) {
                potencia = item.potencia;
              }

              if (!potencia && item.categoria_componentes_id === ID_INVERSOR_CARREGADOR) {
                potencia = Number(item.atributos.find(item => item.atributo === INVERSOR_CARREGADOR_POTENCIA_MAXIMA_FV_ATTR)?.valor || 0)
              }

              if (!potencia && [ID_INVERSOR_ONDA_SENOIDAL, ID_INVERSOR_ONDA_MODIFICADA].includes(item.categoria_componentes_id)) {
                potencia = Number(item.atributos.find(item => item.atributo === INVERSOR_ONDA_POTENCIA_MAXIMA_ATTR)?.valor || 0)
              }

              return {
                ...item,
                potencia,
                valor: 0,
                componente_id: item.id
              }
            });

            Object.assign<typeof state["data"], Partial<typeof state["data"]>>(state.data, { solucao_calculada: {
              baterias: newBaterias,
              controladores: newControladores,
              inversores: newInversores,
              modulo: data.modulo,
            } })

            if (data.modulo?.alterouQuantidade && !!state.data.modulo_selecionado) {
              Object.assign(state.data.modulo_selecionado, { quantidade: data.modulo.quantidade ?? state.data.modulo_selecionado.quantidade ?? 0 });
            }
          })
        },
        changeValue: (newValues: Partial<FormProjetoOffGridType>) => {
          setState(({ state }: ProjetosOffGridStore) => {
            Object.assign<typeof state["data"], Partial<typeof state["data"]>>(state.data, newValues)
          })
        },
        changeModalsValue: (newValues: Partial<FormProjetoOffGridModalsType>) => {
          setState(({ state }: ProjetosOffGridStore) => {
            Object.assign<typeof state["modals"], Partial<typeof state["modals"]>>(state.modals, newValues)
          })
        },
        changeValidationsValue: (newValues: Partial<FormProjetoOffGridValidationsType>) => {
          setState(({ state }: ProjetosOffGridStore) => {
            Object.assign<typeof state["validations"], Partial<typeof state["validations"]>>(state.validations, newValues)
          })
        },
        syncFileiras: (qtdModulo?: number, estruturaSelecionada?: FormProjetoOffGridType["estrutura_selecionada"], alterouQtdModulos?: boolean) => {
          setState(({ state }: ProjetosOffGridStore) => {
            const fileiraNotChanged = state.data.fileiras.length === 1 && state.data.fileiras[0].fileiras === 1 && state.data.fileiras[0].posicao_modulo?.value === 'retrato';

            const formatEstrutura = (): OptionWithEstrutura<number> | null => {
              if (!state.data.estrutura_selecionada) return null;
              const findGrupo = state.data.estrutura_selecionada?.grupos?.find(g => g.id === state.data.estrutura_selecionada?.estruturas_grupo_id) || state.data.estrutura_selecionada?.grupos?.[0];
              let itemImageUrl = findGrupo?.url_imagem || state.data.estrutura_selecionada?.url_imagem || "";

              return {
                image: itemImageUrl,
                text: state.data.estrutura_selecionada.nome,
                value: state.data.estrutura_selecionada.id,
                estruturas_grupo_id: state.data.estrutura_selecionada.estruturas_grupo_id,
                exibir_popup_parceiro: state.data.estrutura_selecionada.exibir_popup_parceiro,
              }
            }

            if (estruturaSelecionada?.id === 0) {
              Object.assign<typeof state["data"], Partial<typeof state["data"]>>(state.data, {
                fileiras: [{
                  fileiras: 1,
                  quantidade_modulos: qtdModulo || state.data.modulo_selecionado?.quantidade || 0,
                  tipo_estrutura: estruturaSelecionada ?
                    { ...estruturaSelecionada, image: estruturaSelecionada.url_imagem, text: estruturaSelecionada.nome, value: estruturaSelecionada.id, estruturas_grupo_id: estruturaSelecionada?.estruturas_grupo_id} :
                    (state.data.estrutura_selecionada ? formatEstrutura() : null),
                  posicao_modulo: POSICAO_MODULO.find(item => item.value === 'retrato') || null,
                }]
              })
              return;
            }

            if (!alterouQtdModulos) {
              return
            }
            
            const totalModulosFileiras = state.data.fileiras.reduce((acc, fileira) => acc + (Number(fileira.fileiras || 0) * Number(fileira.quantidade_modulos || 0)), 0)
            const totalModulosSelecionados = state.data.modulo_selecionado?.quantidade || 0;

            if (totalModulosFileiras === totalModulosSelecionados) {
              Object.assign<typeof state["validations"], Partial<typeof state["validations"]>>(state.validations, { fileiras: { status: true, helper: '' } })
              return;
            }

            if (alterouQtdModulos && !fileiraNotChanged) {
              Object.assign<typeof state["validations"], Partial<typeof state["validations"]>>(state.validations, { fileiras: { status: false, helper: OFFGRID_ERROR_MESSAGES.FILEIRAS_INVALIDAS } })
              return
            }

            Object.assign<typeof state["data"], Partial<typeof state["data"]>>(state.data, {
              fileiras: [{
                fileiras: 1,
                quantidade_modulos: qtdModulo || state.data.modulo_selecionado?.quantidade || 0,
                tipo_estrutura: estruturaSelecionada ?
                  { ...estruturaSelecionada, image: estruturaSelecionada.url_imagem, text: estruturaSelecionada.nome, value: estruturaSelecionada.id, estruturas_grupo_id: estruturaSelecionada?.estruturas_grupo_id} :
                  (state.data.estrutura_selecionada ? formatEstrutura() : null),
                posicao_modulo: POSICAO_MODULO.find(item => item.value === 'retrato') || null,
              }]
            })
          })
        },
        reset: () => {
          setState(({ state }: ProjetosOffGridStore) => {
            Object.assign<typeof state, Partial<typeof state>>(state, INITIAL_STATE)
          })
        },
      },
    }
  },
)
